export function getBaseUrl() {
  let baseUrl
  switch (location.host) {
    case "13hjing.com":
      baseUrl = "http://13hjing.com:8089/sojourn";
      break;
    case "www.13hjing.com":
      baseUrl = "http://13hjing.com:8089/sojourn";
      break;
    default:
      baseUrl = "http://13hjing.com:8089/sojourn";
//       baseUrl = "//127.0.0.1:8088/";
      break;
  }
  return baseUrl
}

export function checkImgByUrl(url) {
  const re = /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/
  return re.test(url)
}

export function isType(type, value) {
  function typeString(value) {
    return Object.prototype.toString.call(value).slice(8, -1)
  }

  return typeString(value) === type
}


//校验&&下载 封装
export function validateAndDownload(validate, downMethod, params) {
  function f(res) {
    const fileName = res.headers.filename || 'excel.xls'
    const blob = new Blob([res.data])

    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()

  }

  if (!validate) {
    return downMethod(params).then(res => {
      f(res)
    })
  } else return validate(params).then(res => {
    return downMethod(params).then(res => {
      f(res)

    })
  })
}


